import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from 'src/app/core/app-config.service';
import { DataService } from 'src/app/core/data.service';
import { Topic } from '../models/topic';
@Injectable({
  providedIn: "root",
})
export class TopicDataService extends DataService<Topic> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "Topics", acs, false);
  } 
}
